import { Component, Input } from '@angular/core';
import { MQService, MQComponent, MQMessage} from '@ngxsuit';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirmdialog.component.html'
})

export class ConfirmDialogComponent extends MQComponent {
  @Input() msg: string;
  @Input() confirmTo: string;
  @Input() overlayDialog: boolean;
  constructor(protected mq: MQService) {
      super(mq);
  }

  cancel() {
    this.mq.notify('close-dialog', {});
  }

  confirm() {
    const confirmTo: string = this.confirmTo ? `confirmed-${this.confirmTo}` : 'confirmed';
    this.mq.notify(confirmTo, {});
    this.cancel();  //close confirm dialog
    if (this.overlayDialog) {
      this.cancel();
    }
  }
}
